<app-text [alias]="'grading_rule_edit_component'"></app-text>
<app-loading-wrapper [loading]="saving || !questions">
    <form *ngIf="formGroup && questions" [formGroup]="formGroup">
        <app-question [question]="questions.gradeLevel" (controlValueChange)="onGradeLevelChange($event)"></app-question>
        <app-question *ngIf="showGradeMode" [question]="questions.gradeMode" (controlValueChange)="onGradeModeChange($event)"></app-question>
        <app-question *ngIf="showValidGrade" [question]="questions.validGrade"></app-question>
        <app-question *ngIf="showValidGrades" [question]="questions.validGradeModes"></app-question>
        <app-question [question]="questions.isEnabled"></app-question>
        <div class="margin-top-lg">
            <app-button-list>
                <app-button #saveButton [loading]="saving" [disabled]="formGroup.invalid" (clickedEvent)="onSave()">Save </app-button>
            </app-button-list>
        </div>
    </form>
</app-loading-wrapper>
